export function getProductSourceInspectSourceIdFromPrefix(
  pathname: string,
  prefix: string
): string | undefined {
  if (!pathname.startsWith(prefix)) {
    return undefined
  }

  const remainder = pathname.slice(prefix.length)
  const sourceId = remainder.split('/')[0] ?? ''
  if (sourceId.length === 0) {
    return undefined
  }

  return sourceId
}

export function getProductSourceInspectPath(
  productDetailPath: string,
  sourceId: string
): string {
  return `${productDetailPath}/sources/${sourceId}`
}

export function getProductSourceInspectSourceId(
  pathname: string,
  productId: string
): string | undefined {
  return getProductSourceInspectSourceIdFromPrefix(
    pathname,
    `/product-catalog/${productId}/sources/`
  )
}

export function getProductDetailPath(productId: string): string {
  return `/product-catalog/${productId}`
}
